import { Box, Grid } from '@material-ui/core';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import BodyAgentInfo from 'components/AgentInfo/BodyAgentInfo';
import HeaderAgentInfo from 'components/AgentInfo/HeaderAgentInfo';
import { InfoItemProps } from 'containers/ServicesPage/types';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import React from 'react';
import { StyledDivider } from '../styles';

const DEFAULT_SEPARATOR = ' - ';

const formatFields = (...fields: string[]): string =>
  [...fields].filter((v) => !!v).join(DEFAULT_SEPARATOR);

const InfoItem = ({ item, close }: InfoItemProps) => {
  return (
    <GaLoadHOC category={EVENT_CATEGORIES.SERVICES} label="Détails">
      <Box mx={2} p={2}>
        <Grid container direction="column">
          <Grid item>
            <Grid container justify="space-between" alignItems="center">
              <Grid item></Grid>
              <Grid item data-testid="close-icon" style={{ cursor: 'pointer' }}>
                <ClearOutlinedIcon onClick={close} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <HeaderAgentInfo
              nameAgent={item.title}
              AdresseAgent={item.subTitle}
              villeAgent={item.ville}
              lat={parseFloat(item.latitude)}
              lng={parseFloat(item.longitude)}
            />
            <StyledDivider />
            <BodyAgentInfo
              horaireLundiJeudi={formatFields(
                item.horaire_lundi_jeudi_matin,
                item.horaire_lundi_jeudi_apres_midi,
              )}
              horaireVendredi={formatFields(
                item.horaire_vendredi_matin,
                item.horaire_vendredi_apres_midi,
              )}
              horaireSamedi={item.horaire_samedi}
              phone={formatFields(item.telephone, item.gsm)}
              email={item.email}
            />
          </Grid>
        </Grid>
      </Box>
    </GaLoadHOC>
  );
};

export default InfoItem;
